import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
	subLabel: {
		color: 'rgba(40, 40, 40, 0.75)',
		fontSize: 10
	},
	separator: {
		marginLeft: 0.5 * theme.spacing.unit,
		marginRight: 0.5 * theme.spacing.unit
	}
});

@withStyles(styles)
class Path extends Component {
	renderPath(item, index, items) {
		const { classes } = this.props;
		const lastItem = index === items.length - 1;
		return (<Typography key={item.id} className={classes.subLabel}>
			{item.displayName}<span className={classes.separator}>{lastItem ? '' : '>'}</span>
		</Typography>);
	}

	render() {
		const { document } = this.props;

		if (!document || !document.path) {
			return null;
		}

		return (<Grid item>
			<Grid container>
				{document.path.map(this.renderPath.bind(this))}
			</Grid>
		</Grid>);
	}
}

Path.propTypes = {
	document: PropTypes.object.isRequired,
	classes: PropTypes.object,
};

export default Path;



// WEBPACK FOOTER //
// ./src/components/TeamFolders/Path.js